import React, { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material';
import { getThemeOptions } from '../lib/util';
export const ThemeProvider = (props) => {
    const { mode = 'light', children, zoomUI } = props;
    const theme = useMemo(() => {
        const defaultTheme = getThemeOptions(mode, zoomUI);
        return createTheme(defaultTheme, {
            components: {
                MuiButtonBase: {
                    defaultProps: {
                        disableRipple: true,
                    },
                },
            },
        });
    }, [mode, zoomUI]);
    return React.createElement(MuiThemeProvider, { theme: theme }, children);
};
